import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    continueJourney: 'Journey step completed',
    continueJourneyReasoning: 'Journey step completed',
    continueJourneyOutput: 'Chose {{toolCall.output.selected.label}}',
    continueJourneyError: 'Error continuing journey',
    selectCoach: 'Select coach',
    selectCoachReasoning: 'Presenting coach selection',
    selectCoachOutput: 'Selected coach',
    selectCoachError: 'Error selecting coach',
    getCoachMatches: 'Get coach matches',
    getCoachMatchesReasoning: 'Matching coaches',
    getCoachMatchesOutput: 'Coach matches',
    getCoachMatchesError: 'Error matching coaches',
  });
  i18next.addResourceBundle('en', 'coaching', {
    jennifer_name: 'Jennifer',
    coach_blaze_name: 'Coach Blaze',
    dr_pragmatic_name: 'Dr. Pragmatic',
    buddy_sam_name: 'Buddy Sam',
    sage_rowan_name: 'Sage Rowan',
    cora_bloom_name: 'Cora Bloom',
    theo_sage_name: 'Theo Sage',
    sergeant_knox_name: 'Sergeant Knox',
    sky_zephyr_name: 'Sky Zephyr',
    master_tao_name: 'Master Tao',
    avery_planwell_name: 'Avery Planwell',
  });
}
